export enum ChartLegendPosition
{
    None = "none",
    Top = "top",
    Right = "right",
    Left = "left",
    Bottom = "bottom"
}